var cov_rmo05976b = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Scroll/styles/index.ts",
      hash = "6652281d8e102ab24612c1327b61e2bd1335865a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Scroll/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var scrollLess = {};
import genaration from '../../utils/classname';
export var scrollClass = (cov_rmo05976b.s[0]++, genaration(scrollLess, 'scroll'));